import { useId } from "react";
import { Mui } from "@osu/react-ui";

const Wrapper = ({ children, open, onClose, year, period, ...rest }) => {
  const id = useId();
  const titleId = `${id}-title`;
  const descriptionId = `${id}-description`;
  const formTitle = `Edit Reporting Period for Year: ${year}, Period: ${period}`;
  return (
    <Mui.Modal
      open={open}
      onClose={onClose}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      {...rest}
    >
      <Mui.Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 600 },
          maxHeight: "90vh",
          overflow: "auto",
          bgcolor: "background.paper",
          borderRadius: 1,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Mui.Typography id={titleId} variant="h6" component="h2" gutterBottom>
          {formTitle}
        </Mui.Typography>

        <Mui.Typography
          id={descriptionId}
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3 }}
        >
          Configure the reporting period and submissions window dates.
        </Mui.Typography>
        {children}
      </Mui.Box>
    </Mui.Modal>
  );
};

export default Wrapper;
